import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ABCDExerciseEmbed from '../components/Exercise/ABCDExerciseEmbed';

export const ABCDExerciseNode = Node.create({
  name: 'abcdExercise',
  
  group: 'block',
  
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      questions: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('questions');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing ABCD questions from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.questions) {
            return {
              questions: JSON.stringify(attributes.questions)
            };
          }
          return {};
        }
      },
      homework: {
        default: false,
        parseHTML: element => {
          const val = element.getAttribute('homework');
          return val === 'true' || val === true;
        },
        renderHTML: attributes => {
          if (typeof attributes.homework !== 'undefined') {
            return { homework: String(!!attributes.homework) };
          }
          return {};
        }
      },
      title: {
        default: 'ABCD Exercise',
        parseHTML: element => element.getAttribute('title') || 'ABCD Exercise',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      // Source text the questions were generated from. Stored on the node
      // (parsed via a JSON-encoded attribute so newlines and quotes survive)
      // so the student can open a collapsible "Read the text" panel from
      // inside the exercise without the teacher having to paste the passage
      // separately elsewhere in the lesson.
      passage: {
        default: '',
        parseHTML: element => {
          const raw = element.getAttribute('passage');
          if (!raw) return '';
          try { return JSON.parse(raw); } catch (_) { return raw; }
        },
        renderHTML: attributes => (
          attributes.passage ? { passage: JSON.stringify(attributes.passage) } : {}
        ),
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      }
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="abcd-exercise"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'abcd-exercise' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(ABCDExerciseEmbed);
  },
});

// Создаем отдельную команду для вставки ABCD exercise
export const insertABCDExercise = (attributes) => ({ commands }) => {
  return commands.insertContent({
    type: 'abcdExercise',
    attrs: attributes,
  });
}; 